module.exports = __webpack_public_path__ + "img/kobatake-mitsuru.6c9dde3a.jpg";